import { getSettingData } from "@/api/myPractice";
import { isObjEmpty } from "./helper";
import { CURRENCY_MAP } from "@/utils/const.js";

const billing = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        infoURL: '/setting/getBillingSetting',
        postpracticeURL: '/setting/setBillingSettingClinic',
        postpersonalURL: '/setting/setBillingSettingCustomer',
        currencyOptions: [],
        currencySymbol: '',
        currency: '',
        processingFeeSettings: null
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        practiceURL: state => state.postpracticeURL,
        notAllowUseRevenue: state => state.old_practice.allowProvidersUsingBillingDelta === 'allow_usage_of_other_credits_only',
        currencyOptions: state => state.currencyOptions,
        currencySymbol: state => state.currencySymbol,
        currency: state => state.currency,
        processingFeeSettings: state => state.processingFeeSettings,
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_DEFAULT(state) {
            state.old_personal = {}
            state.old_practice = {}
        },
        SET_CURRENCY_OPTIONS(state, currencyList) {
            state.currencyOptions = currencyList;
        },
        SET_CURRENCY_SYMBOL(state, currency) {
            let symbol = ""
            if (currency) {
                symbol = CURRENCY_MAP[currency]
            }
            state.currency = currency;
            state.currencySymbol = symbol
        },
        SET_PROCESSING_FEE_SETTINGS(state, settings) {
            state.processingFeeSettings = settings
        }
    },
    actions: {
        async getSettingData({ state, commit, dispatch }) {
            dispatch('setCurrencyOptions');
            if (isObjEmpty(state.old_personal)) {
                const res = await getSettingData(state.infoURL);
                res.data.personal.currency = res.data.practice.currency;
                commit('SET_CURRENCY_SYMBOL', res.data.practice.currency);
                commit("SET_PRACTICE_DATA", res.data.practice)
                commit("SET_PERSONAL_DATA", res.data.personal)
            }
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
        setCurrencyOptions({ state, commit }) {
            let currencies = []
            if (state.currencyOptions.length === 0) {
                currencies = Object.keys(CURRENCY_MAP).map((key) => ({
                    label: key + " (" + CURRENCY_MAP[key] + ")",
                    value: key
                }))
                commit("SET_CURRENCY_OPTIONS", currencies);
            }
        },
        async fetchProcessingFeeSettings({ state, commit }) {
            try {
                const res = await getSettingData('/setting/getBillingSetting');
                if (res.data && res.data.personal) {
                    const settings = {
                        lab_processing_fee: res.data.personal.lab_processing_fee,
                        cap_fee: res.data.personal.cap_fee,
                        reduced_cap_fee: res.data.personal.returning_customer_cap_fee,
                        promotion_from_days: res.data.personal.min_returning_customer_days,
                        promotion_to_days: res.data.personal.returning_customer_days
                    };
                    commit('SET_PROCESSING_FEE_SETTINGS', settings);
                    return settings;
                }
                return null;
            } catch (error) {
                console.error('Error fetching processing fee settings:', error);
                return null;
            }
        },
    },
}


export default billing;